/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bp_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick a solvent and enter a value to convert.`)
};

const es_bp_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige un disolvente e introduce un valor para convertir.`)
};

const de_bp_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie ein Lösungsmittel und geben Sie einen Wert zur Umrechnung ein.`)
};

const nl_bp_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kies een oplosmiddel en voer een waarde in om om te rekenen.`)
};

const fr_bp_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisissez un solvant et entrez une valeur à convertir.`)
};

const it_bp_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scegli un solvente e inserisci un valore da convertire.`)
};

const pt_br2_bp_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolha um solvente e informe um valor para converter.`)
};

const pt_bp_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolha um solvente e introduza um valor para converter.`)
};

const ja_bp_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`溶媒を選び、値を入力して変換してください。`)
};

const zh_bp_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择溶剂并输入数值以进行换算。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bp_hint = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bp_hint(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bp_hint", locale)
	if (locale === "en") return en_bp_hint(inputs)
	if (locale === "es") return es_bp_hint(inputs)
	if (locale === "de") return de_bp_hint(inputs)
	if (locale === "nl") return nl_bp_hint(inputs)
	if (locale === "fr") return fr_bp_hint(inputs)
	if (locale === "it") return it_bp_hint(inputs)
	if (locale === "pt-BR") return pt_br2_bp_hint(inputs)
	if (locale === "pt") return pt_bp_hint(inputs)
	if (locale === "ja") return ja_bp_hint(inputs)
	return zh_bp_hint(inputs)
};